var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app common-content"},[_c('Banner',{attrs:{"BannerImg":_vm.BannerImg}}),_vm._l((_vm.detail),function(item,index){return [_c('TempCarousel',{key:index,attrs:{"item":item}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }